// extracted by mini-css-extract-plugin
export default {"root":"_3_W6F","small":"_17uAT","hideMobile":"_1dn_G"};